export default __webpack_public_path__ + "static/media/expand.470f532d.svg";